import { Button, Stack, Typography } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";

interface CustomProps {
  title: string;
  subtitle2?: any;
  isVisible: boolean;
  btn1Title?: string;
  btn2Title?: string;
  btn1Variant?: "text" | "outlined" | "contained";
  btn2Variant?: "text" | "outlined" | "contained";
  btn1OnClick: Function;
  btn2OnClick: Function;
  isNavsHide?: boolean;
  handleDialogClose: Function;
  persistOnClickOutside?: boolean;
}

const ConfirmationModal = (props: CustomProps) => {
  const getBody = () => {
    return (
      <Stack spacing={3} pt={1}>
        {props.subtitle2 && (
          <Typography textAlign="center">{props.subtitle2}</Typography>
        )}
      </Stack>
    );
  };
  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="contacts_add__cancel_btn"
          variant={props.btn1Variant ? props.btn1Variant : "outlined"}
          size="small"
          onClick={() => props.btn1OnClick()}
        >
          {props.btn1Title ? props.btn1Title : "No"}
        </Button>
        <Button
          id="contacts_add_save_btn"
          variant={props.btn2Variant ? props.btn2Variant : "contained"}
          size="small"
          onClick={async () => await props.btn2OnClick()}
        >
          {props.btn2Title ? props.btn2Title : "Yes"}
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={props.handleDialogClose}
      isDialogOpen={props.isVisible}
      title={
        <Typography variant="h4" color="#7551D0">
          {props.title}
        </Typography>
      }
      body={getBody()}
      footer={getFooter()}
      closeButtonVisibility
      closable
      isNavsHide={props.isNavsHide ?? false}
      maxWidth="sm"
      persistOnClickOutside={props.persistOnClickOutside ?? true}
    />
  );
};

export default ConfirmationModal;
